import React, { useState } from 'react';
import {
  Container,
  TextField,
  Button,
  Typography,
  Box,
  CircularProgress
} from '@mui/material';
import { useSnackbar } from '../../../hooks/SnackbarProvider';
import { APIClient } from '../../../lib/api_client';

const EmailWhitelistPage: React.FC = () => {
  const [email, setEmail] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const { triggerSnackbar } = useSnackbar();

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value);
  };

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setLoading(true);

    if (!email) {
      triggerSnackbar('Email address cannot be empty.', 3000, 'warning');
      setLoading(false);
      return;
    }

    try {
      const response = await APIClient.post('/stanton/whitelist/', { email });
      triggerSnackbar(response.data.message || 'Email added successfully!', 3000, 'success');
      setEmail(''); // Clear input on success
    } catch (error: any) {
      if (error.response && error.response.data && error.response.data.error) {
        triggerSnackbar(error.response.data.error, 3000, 'error');
      } else {
        triggerSnackbar('An unexpected error occurred. Please try again.', 3000, 'error');
      }
      console.error('Error adding email to whitelist:', error);
    }
    setLoading(false);
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ my: 4, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Manage Email Whitelist
        </Typography>
        <Typography variant="body1" gutterBottom>
          Add email addresses to the whitelist for beta program user registration.
        </Typography>
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1, width: '100%' }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={handleEmailChange}
            disabled={loading}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            disabled={loading}          >
            {loading ? <CircularProgress size={24} color="inherit" /> : 'Add to Whitelist'}
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default EmailWhitelistPage; 